import { ValueGetterParams } from "ag-grid-community";

import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { SnowflakeConnection } from "@/services/cloudchipr.api";

export const snowflakeConnectionLastCollectedValueGetter = <
  T extends SnowflakeConnection,
>({
  data,
}: ValueGetterParams<T>) => {
  const lastCollectedDate = data?.last_collected;

  if (!lastCollectedDate) {
    return;
  }

  return `${formatDate(lastCollectedDate ?? "", { type: "dateTime" })}`;
};
